import { BaseJsonGameController } from '@/components/game/implementations/_base/_domain/controller/json-game-controller';
import { injectable, inject } from 'inversify';
import { GameIdentity } from '@/components/game/_domain/models';
import { IServerServiceFactory } from '@/app-modules/server-service';
import { IWinnersTrackerService } from '@/components/game/_domain/modules/winners-tracker-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IConfigurationService } from '@/app-modules/config';
import { IErrorService } from '@/app-modules/error';

@injectable()
class BritainsBiggestBingoGameController extends BaseJsonGameController {

  public constructor(
    @inject(SERVICE_IDENTIFIERS.IConfigurationService) configurationService: IConfigurationService,
    @inject(SERVICE_IDENTIFIERS.IServerServiceFactory) serverServiceFactory: IServerServiceFactory,
    @inject(SERVICE_IDENTIFIERS.IWinnersTrackerService) winnersTrackerService: IWinnersTrackerService,
    @inject(SERVICE_IDENTIFIERS.IErrorService) errorService: IErrorService
  ) {
    super(configurationService, serverServiceFactory, winnersTrackerService, errorService);
  }

  public initialise(gameIdentity: GameIdentity) {
    this.game = this.getInitialGame(gameIdentity);
    this.initialiseGameServerConnection();
    this.initialiseGameRetryPolicySettings();
    this.initialiseGameServerService();
  }

  protected subscribeToGameEvents(): void {
    console.log('subscribeToGameEvents : controller');
    this.serverSubscriptionStore.push(
      this.gameServerService.subscribeCalls(this.handleCallsMessage.bind(this)),
      this.gameServerService.subscribeCountdown(this.handleCountdownMessage.bind(this)),
      this.gameServerService.subscribeWelcome(this.handleWelcomeMessage.bind(this)),
      this.gameServerService.subscribeWinners(this.handleWinnersMessage.bind(this)),
      this.gameServerService.subscribeStart(this.handleStartMessage.bind(this))
    );
  }
}

export { BritainsBiggestBingoGameController };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/britains-biggest-bingo/_domain/controller/game-controller.ts